var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cbm-card',{attrs:{"title":"Unidades elegíveis","number-text":_vm.value,"tooltip":"Venda total dos produtos participantes da campanha que cumpriram os requisitos para ganhar o benefício","simple-card":"","boolean-loader":_vm.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }